var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BC5353",
  fillRule: "evenodd",
  d: "M.75 14.75h16.5L9 .5.75 14.75Zm9-2.25h-1.5V11h1.5v1.5Zm0-3h-1.5v-3h1.5v3Z",
  clipRule: "evenodd"
})));
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjc1IDE0Ljc1SDE3LjI1TDkgMC41TDAuNzUgMTQuNzVaTTkuNzUgMTIuNUg4LjI1VjExSDkuNzVWMTIuNVpNOS43NSA5LjVIOC4yNVY2LjVIOS43NVY5LjVaIiBmaWxsPSIjQkM1MzUzIi8+Cjwvc3ZnPgo=";